export const getNetCost = (grossCost: number) => Math.round((+grossCost / 1.2) * 100) / 100;
export const getVatCost = (grossCost: number) =>
    grossCost - Math.round((+grossCost / 1.2) * 100) / 100;

export const formatPrice = (value) =>
    typeof value === 'number' ? `£${Number(value / 100).toFixed(2)}` : value;

export const formatPounds = (valueInPounds: number) =>
    (typeof valueInPounds === 'number' ? valueInPounds : 0).toFixed(2);
